import { useState, useMemo, useEffect } from 'react';
import { useQueryParams } from '@/hooks';
import { CommerceSettingsFilters } from '../models';

export function useCommerceSettingsFilter() {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: CommerceSettingsFilters = useMemo(
    () => ({
      key: '',
      value: '',
    }),
    []
  );

  const [filters, setFilters] = useState<CommerceSettingsFilters>(() => ({
    key: getQueryParam('key') || initialFilter.key,
    value: getQueryParam('value') || initialFilter.value,
  }));

  useEffect(() => {
    setQueryParams({
      key: filters.key || undefined,
      value: filters.value || undefined,
    });
  }, [filters]);

  return {
    filters,
    setFilters,
    initialFilter,
  };
}
